export * from "./inits";

export const digitLengthOf = (value) => value.replaceAll(/\D/g, "").length;
